import React from 'react';
import PropTypes from 'prop-types';
import { Input, Tooltip } from '@salesforce/design-system-react';
const CompanyGoal = (props) => {
  return (
    <div className={props.className}>
      <Input
        label="Company Goal"
        id="company-goal-input"
        value={props.value}
        refs="companyGoal"
        onChange={props.onChange}
        fieldLevelHelpTooltip={
          <Tooltip
            align="right"
            content="Start off your Business Challenge as a 'how might we' proposition. Think of it as two fill-in-the-blanks: the Verb, and the Metric."
            variant="learnMore"
          />
        }
      />
      <div
        style={{ marginTop: '5px', color: '#aaaaaa' }}
        className="slds-text-heading_small"
      >
        <i>
          You'll want to address your customer's primary problem that they want
          to overcome, such as: drive top line revenue in our example above.
          Another example is increase customer engagement."
        </i>
      </div>
    </div>
  );
};

CompanyGoal.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CompanyGoal;
